import { css } from 'styled-components';
import type { TypeLayoutDetailed } from 'types/autogen/contentful';

const oneColumn = css`
    grid-template-columns: repeat(1, minmax(0, 1fr));
`;
const twoColumns = css`
    grid-template-columns: repeat(2, minmax(0, 1fr));
`;
const OneFullTwoHalves = css`
    grid-template-columns: repeat(2, minmax(0, 1fr));

    & > :nth-child(3n+1) {
        grid-column: span 2;
    }
`;

export default function getMobileLayout(layoutOnMobile: TypeLayoutDetailed['fields']['layoutOnMobile']) {
    switch (layoutOnMobile) {
        case '1:1':
            return oneColumn;
        case '1:2.1:2':
            return twoColumns;
        case '1:1.1:1(1:2.1:2)':
            return OneFullTwoHalves;
        default:
            console.error(`${layoutOnMobile} is not recognized as a valid type`);
            return oneColumn;
    }
}
